export default __webpack_public_path__ + "static/media/NoAlert.7f31f26c.svg";